export const bdi_label = {
    Primary: 'Primary',
    Secondary: 'Secondary',
    Success: 'Success',
    Info: 'Info',
    Warning: 'Warning',
    Help: 'Help',
    Danger: 'Danger',
    Submit: 'Submit',
    Disabled: 'Disabled',
    Link: 'Link',
    Plain: 'Plain',
    Save: 'Save',
    Delete: 'Delete',
    Cancel: 'Cancel',
    Update: 'Update',
    Home: 'Home'
};

export const bdi_icon = {
    check: 'pi pi-check',
    trash: 'pi pi-trash',
    times: 'pi pi-times',
    star: 'pi pi-star',
    bookmark: 'pi pi-bookmark',
    search: 'pi pi-search',
    user: 'pi pi-user',
    sign_out: 'pi pi-sign-out',
    bell: 'pi pi-bell',
    heart: 'pi pi-heart',
    filter: 'pi pi-filter',
    refresh: 'pi pi-refresh',
    home: 'pi pi-home',
    plus: 'pi pi-plus',
    minus: 'pi pi-minus'
};

export const bdi_iconposition = {
    left: 'left',
    center: 'center',
    right: 'right'
};

export const bdi_classe = {
    default: 'p-button-default',
    severities: 'p-button-severities',
    text: 'p-button-text',
    outlined: 'p-button-outlined',
    buttonset: 'p-buttonset',
    link: 'p-button-link',
    split: 'p-button-split',
    badge: 'badge',
    rounded: 'p-button-rounded'
};

export const bdi_subclasse = {
    primary: 'p-button-primary',
    secondary: 'p-button-secondary',
    success: 'p-button-success',
    info: 'p-button-info',
    warning: 'p-button-warning',
    danger: 'p-button-danger'
};

export const bdi_type = {
    line: 'line',
    pie: 'pie',
    polarArea: 'polarArea',
    bar: 'bar',
    doughnut: 'doughnut',
    radar: 'radar'
};

export const bdi_severity = {
    success: 'success',
    error: 'error',
    warning: 'warning',
    warn: 'warn',
    info: 'info'
};

export const bdi_mode = {
    basic: 'basic'
};

export const bdi_size = {
    small: 'small',
    large: 'large',
    xlarge: 'xlarge'
};

export const bdi_alinhamento_lateral = 'p-mr-2';

export const bdi_alinhamento_vertical = 'p-mb-2';